import React from "react";
import {ButtonLinkStyle} from "../../../../Components/Inputs";
import {emptyGuid} from "../../../../Utilities/commonUtilities";

interface BraillerCatalogResultsRowProps {
    catalogResource: Record<string, any>;
    canManageCatalog?: boolean;
    handleAddToQueue: (id: string) => void;
    handleEdit: (id: string) => void;
    handleRepairs?: (id: string) => void;
}

export const BraillerCatalogResultsRow = ({
                                              catalogResource,
                                              canManageCatalog,
                                              handleAddToQueue,
                                              handleEdit,
                                              handleRepairs,
                                          }: BraillerCatalogResultsRowProps) => {

    const handleClickEdit = () => {
        const itemId = catalogResource.braillerCatalogId;
        if (itemId && itemId !== emptyGuid) {
            handleEdit(itemId);
        }
    };

    const handleClickAddToQueue = () => {
        const itemId = catalogResource.braillerCatalogId;
        if (itemId && itemId !== emptyGuid) {
            handleAddToQueue(itemId);
        }
    };

    const handleClickRepairs = () => {
        const itemId = catalogResource.braillerCatalogId;
        if (itemId && itemId !== emptyGuid) {
            handleRepairs?.(itemId);
        }
    };

    const getAvailabilityText = () => {
        const available = catalogResource.quantityCurrentlyAvailable || 0;
        const total = catalogResource.totalQuantity || 0;
        return `${available} out of ${total} available`;
    };

    const isAvailable = (catalogResource.quantityCurrentlyAvailable || 0) > 0;

    return (
        <tr id={catalogResource.catalogNumber} data-testid={catalogResource.catalogNumber}>
            <td>{catalogResource.title}</td>
            <td>{catalogResource.model}</td>
            <td>{catalogResource.cost ? `$${catalogResource.cost.toFixed(2)}` : ''}</td>
            <td>{getAvailabilityText()}</td>
            <td>
                {canManageCatalog && (
                    <>
                        <ButtonLinkStyle
                            label="Edit Item"
                            name={`btnEdit${catalogResource.braillerCatalogId}`}
                            onClick={handleClickEdit}
                        />
                        <span>&nbsp;&nbsp;&nbsp;</span>
                    </>
                )}
                {catalogResource.allowRepairs && (
                    <>
                        <ButtonLinkStyle
                            label="Repairs"
                            name={`btnRepairs${catalogResource.braillerCatalogId}`}
                            onClick={handleClickRepairs}
                        />
                        <span>&nbsp;&nbsp;&nbsp;</span>
                    </>
                )}
                <ButtonLinkStyle
                    label={isAvailable ? "Add to Queue" : "Add to Waitlist"}
                    name={`btnAddQueue${catalogResource.braillerCatalogId}`}
                    onClick={handleClickAddToQueue}
                />
            </td>
        </tr>
    );
};

